export default {
  header: {
    notes: 'Configuration section for crushers',
    message: 'Configuration',
  },
  model: {
    equipmentRevision: {
      notes: 'Label for Equipment revision',
      message: 'Equipment revision',
    },
    oilTankType: {
      notes: 'Label for Oil tank type',
      message: 'Oil tank type',
    },
    oilTankRevision: {
      notes: 'Label for Oil tank revision',
      message: 'Oil tank revision',
    },
    automationSystemType: {
      notes: 'Label for Automation system type',
      message: 'Automation system type',
    },
    automationSystemVersion: {
      notes: 'Label for Automation system version',
      message: 'Automation system version',
    },
  },
};
